export default {"src":"/_next/static/media/sent.e85811d7.svg","height":77,"width":146,"blurWidth":0,"blurHeight":0};